<template>
    <section class="o-page-bottom-spacing">
        <page-header>
            <slot slot="title">{{ $t('country.page_header_edit') }}</slot>
        </page-header>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div class="u-max-700 c-form-row">
                    <v-form-row>
                        <v-input v-model="Country.NameNL" name="nameNL" :fluid="true" :error="Validate.NameNL">
                            <slot slot="label">{{ $t('country.label.dutch') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="Country.NameFR" name="nameFR" :fluid="true" :error="Validate.NameFR">
                            <slot slot="label">{{ $t('country.label.french') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="Country.NameEN" name="nameEN" :fluid="true" :error="Validate.NameEN">
                            <slot slot="label">{{ $t('country.label.english') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-switch v-model="Country.IsAvailable" name="isAvailable">
                            <slot slot="label">{{ $t('country.label.is_available') }}</slot>
                        </v-switch>
                    </v-form-row>
                    <v-form-row>
                        <h3 class="u-pull-left">Kosten</h3>
                        <div class="u-pull-right">
                            <v-add-costs
                                    v-if="availableCurrencies.length > 0"
                                    @costsAdded="addCosts"
                                    :countryId="Country.Id"
                                    :currencyOptions="availableCurrencies">
                            </v-add-costs>
                        </div>
                        <table-component v-if="Country.Costs && Country.Costs.length > 0" class="o-page-row" table-class="c-table c-table--small" :data="Country.Costs" :show-caption="false" :show-filter="false">
                            <table-column key="CurrencyId" :sortable="false">
                                <template slot-scope="row">
                                    {{ getCurrencyCode(row.CurrencyId) }}
                                </template>
                            </table-column>
                            <table-column key="ShippingCosts" :label="$t('country.label.shipping_costs')" :sortable="false">
                                <template slot-scope="row">
                                    {{ row.ShippingCosts | currency(getCurrencySymbol(row.CurrencyId)) }}
                                </template>
                            </table-column>
                            <table-column key="DropShipmentCosts" :label="$t('country.label.dropshipment_costs')" :sortable="false">
                                <template slot-scope="row">
                                    {{ row.DropShipmentCosts | currency(getCurrencySymbol(row.CurrencyId)) }}
                                </template>
                            </table-column>
                            <table-column key="FreeDeliveryShippingCosts" :label="$t('country.label.free_delivery_shipping_costs')" :sortable="false">
                                <template slot-scope="row">
                                    {{ row.FreeDeliveryShippingCosts | currency(getCurrencySymbol(row.CurrencyId)) }}
                                </template>
                            </table-column>
                            <table-column key="FreeDeliveryDropShipmentCosts" :label="$t('country.label.free_delivery_dropShipment_costs')" :sortable="false">
                                <template slot-scope="row">
                                    {{ row.FreeDeliveryDropShipmentCosts | currency(getCurrencySymbol(row.CurrencyId)) }}
                                </template>
                            </table-column>
                            <table-column cell-class="u-text-nowrap u-text-align-center" :sortable="false">
                                <template slot-scope="row">
                                    <v-edit-costs :costs="row" :currencyCode="getCurrencyCode(row.CurrencyId)" class="edit-costs-button"></v-edit-costs>
                                    <button type="button" class="c-button c-button--tiny c-button--alpha" @click="deleteCosts(row.CurrencyId)">
                                        <svgicon name="cross" class="svg-icon svg-fill"></svgicon>
                                    </button>
                                </template>
                            </table-column>
                        </table-component>
                        <div v-else class="u-font-large u-text-align-center u-padding">
                            {{ $t('country.label.no_costs_found') }}
                        </div>
                    </v-form-row>
                    <v-form-row>
                        <div class="c-form-item u-pull-right">
                            <v-label></v-label>
                            <button @click="submitForm" class="c-button c-button--alpha">{{ $t('country.button.edit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>
    </section>
</template>
<script>
    import VLoading from '@/components/Loading'
    import PageHeader from '@/components/common/PageHeader'
    import VInput from '@/components/form/Input'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VSwitch from '@/components/form/Switch'
    import _find from 'lodash/find'
    import VAddCosts from '@/components/countries/AddCosts'
    import VEditCosts from '@/components/countries/EditCosts'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VLabel,
            VInput,
            VFormRow,
            VSwitch,
            VAddCosts,
            VEditCosts
        },
        data() {
            return {
                Validate: {},
                loaded: {}
            }
        },
        computed: {
            ...mapGetters({
                Country: 'Country',
                CurrencyOptions: 'CurrencyOptions'
            }),
            availableCurrencies(){
                let currencies = [];

                if(this.loaded.isLoaded){
                    this.CurrencyOptions.forEach((item) => {
                        let exists = _find(this.Country.Costs, {'CurrencyId': item.Id});

                        if(!exists){
                            currencies.push(item);
                        }
                    });
                }

                return currencies;
            }
        },
        created: function () {
            this.$store.dispatch('getCurrencyOptions').then(() => {
                this.$store.dispatch('getCountry', this.$attrs.id).then(() => {
                    this.loaded = { isLoaded: true }
                });
            });
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            submitForm(e) {
                this.loaded = {}

                this.$store.dispatch('updateCountry', this.Country).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        this.$router.push({
                            name: 'CountriesOverview'
                        });
                    }
                    this.loaded = { isLoaded: true }
                }).catch(() => {
                    this.loaded = { isLoaded: true };
                });
                e.preventDefault();
            },
            getCurrencyCode(currencyId){
                let currency = _find(this.CurrencyOptions, {'Id': currencyId});

                if(currency){
                    return currency.Code;
                }
            },
            getCurrencySymbol(currencyId){
                let currency = _find(this.CurrencyOptions, {'Id': currencyId});

                if(currency){
                    return currency.Symbol;
                }
            },
            addCosts(newCosts){
                this.Country.Costs.push(newCosts);
            },
            deleteCosts(currencyIdToDelete){
                this.Country.Costs = this.Country.Costs.filter(function(item){
                    return item.CurrencyId !== currencyIdToDelete;
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "~@/assets/scss/private";
    .edit-costs-button {
        display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/views/admin/countries/Edit.vue